/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_KeepInputs */

const cs_client_merge_keep = /** @type {(inputs: Client_Merge_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponechat (cíl)`)
};

const en_client_merge_keep = /** @type {(inputs: Client_Merge_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep (target)`)
};

/**
* | output |
* | --- |
* | "Keep (target)" |
*
* @param {Client_Merge_KeepInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_keep = /** @type {((inputs?: Client_Merge_KeepInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_KeepInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_keep(inputs)
	return cs_client_merge_keep(inputs)
});